RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Landscapes = Backbone.Collection.extend({
        url: function () {
            const me = this;
            return `/api/account/${me.account_id}/landscapes`;
        },

        comparator: function (a, b) {
            return a.get('name').localeCompare(b.get('name'));
        }
    });
});
